/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Display_Overwrite_Failed_ToastInputs */

const en_explorer_display_overwrite_failed_toast = /** @type {(inputs: Explorer_Display_Overwrite_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to overwrite project: ${i?.error}`)
};

const fr_explorer_display_overwrite_failed_toast = /** @type {(inputs: Explorer_Display_Overwrite_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'ecrasement du projet : ${i?.error}`)
};

const de_explorer_display_overwrite_failed_toast = /** @type {(inputs: Explorer_Display_Overwrite_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projekt konnte nicht überschrieben werden: ${i?.error}`)
};

const it_explorer_display_overwrite_failed_toast = /** @type {(inputs: Explorer_Display_Overwrite_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile sovrascrivere il progetto: ${i?.error}`)
};

const ru_explorer_display_overwrite_failed_toast = /** @type {(inputs: Explorer_Display_Overwrite_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось перезаписать проект: ${i?.error}`)
};

const es_explorer_display_overwrite_failed_toast = /** @type {(inputs: Explorer_Display_Overwrite_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo sobrescribir el proyecto: ${i?.error}`)
};

const zh_cn2_explorer_display_overwrite_failed_toast = /** @type {(inputs: Explorer_Display_Overwrite_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`覆盖项目失败：${i?.error}`)
};

const ja_explorer_display_overwrite_failed_toast = /** @type {(inputs: Explorer_Display_Overwrite_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクトの上書きに失敗しました: ${i?.error}`)
};

const hi_explorer_display_overwrite_failed_toast = /** @type {(inputs: Explorer_Display_Overwrite_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट को ओवरराइट करने में विफल: ${i?.error}`)
};

const pt_pt2_explorer_display_overwrite_failed_toast = /** @type {(inputs: Explorer_Display_Overwrite_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao sobrescrever o projeto: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to overwrite project: {error}" |
*
* @param {Explorer_Display_Overwrite_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_overwrite_failed_toast = /** @type {((inputs: Explorer_Display_Overwrite_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Overwrite_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_overwrite_failed_toast(inputs)
	if (locale === "de") return de_explorer_display_overwrite_failed_toast(inputs)
	if (locale === "it") return it_explorer_display_overwrite_failed_toast(inputs)
	if (locale === "ru") return ru_explorer_display_overwrite_failed_toast(inputs)
	if (locale === "es") return es_explorer_display_overwrite_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_overwrite_failed_toast(inputs)
	if (locale === "ja") return ja_explorer_display_overwrite_failed_toast(inputs)
	if (locale === "hi") return hi_explorer_display_overwrite_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_overwrite_failed_toast(inputs)
	return en_explorer_display_overwrite_failed_toast(inputs)
});